"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagBO = function FlagBO(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-193,56.91H216.6V139.3a7.06,7.06,0,0,1-7.06,7.06H-185.94A7.06,7.06,0,0,1-193,139.3Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-185.94-122H209.54a7.06,7.06,0,0,1,7.06,7.06v82.39H-193v-82.39a7.06,7.06,0,0,1,7.06-7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "90.45",
    width: "409.6",
    height: "89.44",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M2.68-27.86l-.52.66A18.28,18.28,0,0,0,1-25.4a14.65,14.65,0,0,0-1.91,7,14.72,14.72,0,0,0,.78,4.57A13.85,13.85,0,0,0,2.39-9.46,12.37,12.37,0,0,0,6.6-6.37a11.25,11.25,0,0,0,2.53.85c.43.13.88.13,1.32.22a5,5,0,0,0,.67,0l.34,0h.32c-.07,0,.18,0-.15,0,.55,0,1.21,0,1.66-.09s.73-.08,1.18-.21A11.25,11.25,0,0,0,17-6.37a12.46,12.46,0,0,0,4.21-3.09,13.91,13.91,0,0,0,2.54-4.32,14.59,14.59,0,0,0,.77-4.59,14.68,14.68,0,0,0-1.9-7,19.43,19.43,0,0,0-1.19-1.82l-.49-.62,0-.05a.89.89,0,0,1,.15-1.26.91.91,0,0,1,1-.05l.75.48a15.13,15.13,0,0,1,2,1.63,15.66,15.66,0,0,1,4.28,8.24,16.42,16.42,0,0,1-.1,6.46,16.84,16.84,0,0,1-3,6.71A17.39,17.39,0,0,1,19.86-.53,16.61,16.61,0,0,1,16,.92a17.82,17.82,0,0,1-2.21.38c-.69.08-1.18.08-1.78.13h-.69l-.53,0c-.35,0-.7,0-1.05-.09A20.17,20.17,0,0,1,7.64.92,16.45,16.45,0,0,1,3.74-.53,17.5,17.5,0,0,1-2.35-5.68a16.9,16.9,0,0,1-3-6.71,16.29,16.29,0,0,1-.1-6.47,15.6,15.6,0,0,1,4.29-8.23,15.2,15.2,0,0,1,2-1.65l.71-.44a.89.89,0,0,1,1.24.28.9.9,0,0,1-.06,1Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10,42.47V53.65a1.26,1.26,0,0,1-2.14.89l-.62-.62A2.73,2.73,0,0,1,6.48,52V42.47Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.7,40.7v8.11a1.81,1.81,0,0,0,.54,1.3l1.24,1.24V40.7Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M2.93,40.7v4.35a2.35,2.35,0,0,0,.68,1.66L4.7,47.8V40.7Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.57,42.47V53.65a1.26,1.26,0,0,0,2.14.89l.61-.62a2.7,2.7,0,0,0,.8-1.93V42.47Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18.9,40.7v8.11a1.85,1.85,0,0,1-.54,1.3l-1.24,1.24V40.7Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.67,40.7v4.35A2.35,2.35,0,0,1,20,46.71L18.9,47.8V40.7Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.67,8.75,40.19-5.45v29.2A15.18,15.18,0,0,1,17,36.62L6.48,30.05V8.5Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M33.1-.29V20.2A15.18,15.18,0,0,1,17.93,35.38a15.5,15.5,0,0,1-3.72-.49L6.48,30.05V8.5l14.19.25Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M27.77,3.59V16.81A15.17,15.17,0,0,1,12.6,32a15.41,15.41,0,0,1-3.71-.48L6.48,30V8.5l14.19.25Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M41.26-8.64l7.81-3.91-5.68,7.1h-3.2Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M31.32,17.63,50.84,3.43v29.2A15.16,15.16,0,0,1,27.63,45.49L17.12,38.92V17.38Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M38.42,12.46V25.69A15.17,15.17,0,0,1,23.25,40.86a14.93,14.93,0,0,1-3.71-.49l-2.42-1.51V17.38l14.2.25Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M51.91.23l7.81-3.9L54,3.43h-3.2Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M26,14.07,45.52-.12V29.07A15.16,15.16,0,0,1,22.31,41.94L11.8,35.37V13.83Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M38.42,5V25.53A15.17,15.17,0,0,1,23.25,40.7a14.93,14.93,0,0,1-3.71-.49L11.8,35.37V13.83l14.2.24Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M33.1,8.91V22.14A15.17,15.17,0,0,1,17.93,37.31a15,15,0,0,1-3.72-.49L11.8,35.31V13.83l14.2.25Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M46.59-3.32l7.8-3.9L48.71-.12H45.52Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M2.93,8.75-16.6-5.45v29.2A15.17,15.17,0,0,0-1.43,38.92a15.27,15.27,0,0,0,8.05-2.3l10.5-6.57V8.5Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-9.5-.29V20.2A15.18,15.18,0,0,0,5.67,35.38a15.5,15.5,0,0,0,3.72-.49l7.73-4.84V8.5L2.93,8.75Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-4.17,3.59V16.81A15.17,15.17,0,0,0,11,32a15.41,15.41,0,0,0,3.71-.48L17.12,30V8.5L2.93,8.75Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-17.66-8.64l-7.81-3.91,5.68,7.1h3.19Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-7.72,17.63-27.25,3.43v29.2A15.18,15.18,0,0,0-12.07,47.8a15.18,15.18,0,0,0,8-2.31L6.48,38.92V17.38Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-14.82,12.46V25.69A15.17,15.17,0,0,0,.35,40.86a14.93,14.93,0,0,0,3.71-.49l2.42-1.51V17.38l-14.2.25Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-28.31.23l-7.81-3.9,5.68,7.1h3.19Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-2.4,14.07-21.92-.12V29.07A15.18,15.18,0,0,0-6.75,44.25a15.15,15.15,0,0,0,8-2.31L11.8,35.37V13.83Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-14.82,5V25.53A15.17,15.17,0,0,0,.35,40.7a14.93,14.93,0,0,0,3.71-.49l7.74-4.84V13.83l-14.2.24Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-9.5,8.91V22.14A15.17,15.17,0,0,0,5.67,37.31a15,15,0,0,0,3.72-.49l2.41-1.51V13.83l-14.2.24Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-11.44,40.46l-2.34-2.34A3.55,3.55,0,0,1-13.7,33L25-3.37l5,5L-6.34,40.38a3.55,3.55,0,0,1-5.1.08Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffbe5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-10.83,39.29a1.78,1.78,0,0,1-1.78,1.78,1.78,1.78,0,0,1-1.77-1.78,1.77,1.77,0,0,1,1.77-1.77,1.78,1.78,0,0,1,1.78,1.77Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffbe5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M25-3.37c.69-.69,2.38-.13,3.76,1.25S30.75,1,30.06,1.65s-2.38.13-3.77-1.26S24.35-2.68,25-3.37Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M35,40.46l2.34-2.34A3.55,3.55,0,0,0,37.3,33L-1.44-3.37l-5,5,36.4,38.74a3.55,3.55,0,0,0,5.1.08Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffbe5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M38,39.29a1.78,1.78,0,1,1-1.77-1.77A1.78,1.78,0,0,1,38,39.29Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffbe5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-1.43-3.37C-.74-2.68-1.3-1-2.69.39S-5.76,2.34-6.45,1.65-6.58-.73-5.2-2.11s3.08-1.95,3.77-1.26Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M27.49,20.29c0,10.29-7,18.64-15.69,18.64S-3.9,30.58-3.9,20.29s7-18.63,15.7-18.63S27.49,10,27.49,20.29Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffbe5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.8,3.43,12.63,7l1.91-3.18-.33,3.7L17,5.12,15.57,8.54,19,7.09,16.54,9.88l3.7-.32-3.18,1.91,3.61.83-3.61.83L20.24,15l-3.7-.32L19,17.52l-3.41-1.45L17,19.48,14.21,17l.33,3.7-1.91-3.18-.83,3.62L11,17.56,9.06,20.74,9.38,17,6.59,19.48,8,16.07,4.62,17.52l2.43-2.8L3.36,15l3.18-1.91L2.93,12.3l3.61-.83L3.36,9.56l3.69.32L4.62,7.09,8,8.54,6.59,5.12,9.38,7.56l-.32-3.7L11,7Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M31.43,20s-5.88,1.56-9.7-1.66a41.42,41.42,0,0,0-8.81-5.9,1.77,1.77,0,0,0-1.46,0,18.64,18.64,0,0,0-4.37,2.79C4.75,17.24-2.4,21.29-3.84,21.29v8.82L7.42,39.87l13.31-.39Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.8,43.36C.54,43.36-8.61,33-8.61,20.29S.54-2.79,11.8-2.79,32.21,7.57,32.21,20.29,23.05,43.36,11.8,43.36Zm0-40.82c-8.32,0-15.09,8-15.09,17.75S3.48,38,11.8,38s15.09-8,15.09-17.75S20.12,2.54,11.8,2.54Zm0,0",
    transform: "translate(194 123)",
    fill: "#3cc8ff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8.74,38.54l.39,1.17h1.24a.16.16,0,0,1,.09.3l-1,.73.37,1.18a.16.16,0,0,1-.25.19l-1-.72-1,.72a.17.17,0,0,1-.26-.19l.38-1.18L6.7,40a.17.17,0,0,1,.1-.3H8l.4-1.17a.16.16,0,0,1,.31,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffbe5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M3.2,36.15l.39,1.17H4.82a.17.17,0,0,1,.1.3l-1,.74.37,1.18a.17.17,0,0,1-.26.18L3,39l-1,.72a.17.17,0,0,1-.26-.18l.38-1.18-1-.74a.17.17,0,0,1,.1-.3H2.49l.39-1.17a.17.17,0,0,1,.32,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffbe5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-1.26,32.1l.39,1.17,1.24,0a.16.16,0,0,1,.09.3l-1,.73.37,1.18a.16.16,0,0,1-.25.18l-1-.72-1,.72a.16.16,0,0,1-.25-.18l.37-1.18-1-.73a.17.17,0,0,1,.1-.3l1.23,0,.39-1.17a.17.17,0,0,1,.32,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffbe5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-4.3,26.71l.39,1.18h1.24a.17.17,0,0,1,.1.31l-1,.73.37,1.18a.16.16,0,0,1-.25.18l-1-.72-1,.72a.16.16,0,0,1-.25-.18l.37-1.18-1-.73a.17.17,0,0,1,.1-.31H-5l.4-1.18a.16.16,0,0,1,.31,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffbe5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-5.64,20.45l.39,1.17H-4a.17.17,0,0,1,.1.3l-1,.73.37,1.18a.16.16,0,0,1-.25.19l-1-.72-1,.72a.17.17,0,0,1-.25-.19l.37-1.18-1-.73a.17.17,0,0,1,.1-.3h1.23L-6,20.45a.17.17,0,0,1,.32,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffbe5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14.85,38.54l-.39,1.17H13.22a.17.17,0,0,0-.1.3l1,.73-.37,1.18a.16.16,0,0,0,.25.19l1-.72,1,.72a.17.17,0,0,0,.26-.19l-.38-1.18,1-.73a.17.17,0,0,0-.1-.3H15.55l-.39-1.17a.16.16,0,0,0-.31,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffbe5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.4,36.15,20,37.32H18.77a.17.17,0,0,0-.1.3l1,.74-.38,1.18a.17.17,0,0,0,.26.18l1-.72,1,.72a.17.17,0,0,0,.26-.18l-.38-1.18,1-.74a.17.17,0,0,0-.1-.3H21.1l-.39-1.17a.16.16,0,0,0-.31,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffbe5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24.85,32.1l-.39,1.17-1.23,0a.17.17,0,0,0-.1.3l1,.73-.37,1.18a.16.16,0,0,0,.25.18L25,35l1,.72a.16.16,0,0,0,.25-.18l-.37-1.18,1-.73a.16.16,0,0,0-.09-.3l-1.24,0-.39-1.17a.17.17,0,0,0-.32,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffbe5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M27.89,26.71l-.39,1.18H26.27a.17.17,0,0,0-.1.31l1,.73-.37,1.18a.16.16,0,0,0,.25.18l1-.72,1,.72a.17.17,0,0,0,.26-.18l-.37-1.18,1-.73a.17.17,0,0,0-.1-.31H28.6l-.39-1.18a.17.17,0,0,0-.32,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffbe5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M29.23,20.45l-.39,1.17H27.6a.16.16,0,0,0-.09.3l1,.73-.37,1.18a.16.16,0,0,0,.25.19l1-.72,1,.72a.17.17,0,0,0,.26-.19l-.37-1.18,1-.73a.16.16,0,0,0-.09-.3H29.94l-.39-1.17a.17.17,0,0,0-.32,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffbe5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.09,31.66l.59,2.82h.25V32.56a5.82,5.82,0,0,0,1,1.92h.49A2.71,2.71,0,0,1,5.78,33c0-.88.7-1,.7-1.93h.59v3.46h.35l.65-3.09A9.3,9.3,0,0,0,9.6,34.48H10A5.53,5.53,0,0,1,9.18,31a2,2,0,0,0,1-1.77V27.36a.63.63,0,0,1,.62-.63h.43s-.64-1.23-1.32-1.41v-.77l-.51.77a1,1,0,0,0-.78,1v1.12a.63.63,0,0,1-.62.63H5.72c-.65,0-1.71.65-1.71,1.5A2,2,0,0,0,4.64,31Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14.05,28.86h-.2A3.72,3.72,0,0,0,11.34,30L13,31.64v3.08h2V31.64L16.57,30a3.72,3.72,0,0,0-2.52-1.14Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffbe5a"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "211.5",
    y: "146.82",
    width: "0.59",
    height: "10.91",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.81,23.73l-3.19,3.86a4.2,4.2,0,0,1,1.44-3.69l-4.1.75a4.64,4.64,0,0,1,4.52-2.08l-3.36-2.8a5.31,5.31,0,0,1,4.36,2s.83-2.5,3.16-2.61l-1.93,2.92A6.41,6.41,0,0,1,23.3,22l-4,1.06s2.22.22,3.14,3.46L19,24.12a4.78,4.78,0,0,1,.67,3.69Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-23-3.32l-7.82-3.9,5.69,7.1h3.19Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.35-7.84l21.07-6.48-11.18-4.2A17.93,17.93,0,0,0,21-19.64H18.9a1.78,1.78,0,0,0-1.78,1.77v1.77H6.48v-1.77A1.78,1.78,0,0,0,4.7-19.64H2.59a17.88,17.88,0,0,0-6.23,1.12l-11.18,4.2L6.25-7.84A1.77,1.77,0,0,1,7.31-5.35L4.7-.12H18.9L16.28-5.35a1.78,1.78,0,0,1,1.07-2.49Zm0,0",
    transform: "translate(194 123)",
    fill: "#825546"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.35-14.32a3.54,3.54,0,0,1-3.55,3.54,3.54,3.54,0,0,1-3.55-3.54,3.54,3.54,0,0,1,3.55-3.55,3.54,3.54,0,0,1,3.55,3.55Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.57-14.32a1.77,1.77,0,0,1-1.77,1.77H4.7l3-3A1.76,1.76,0,0,1,9-16.1H11.8a1.78,1.78,0,0,1,1.77,1.78Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffbe5a"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagBO;
exports["default"] = _default;